import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [business, setBusiness] = useState(null);

  const loadBusiness = useCallback(async () => {
    try {
      const { data } = await api.get("/business");
      setBusiness(data);
      return data;
    } catch {
      setBusiness(null);
      return null;
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (data.business_id) await loadBusiness();
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, [loadBusiness]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    if (data.business_id) await loadBusiness();
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
    setBusiness(null);
  };

  return (
    <AuthContext.Provider value={{ user, business, setBusiness, loadBusiness, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
